import { IconButton, useTheme } from "@mui/material";
import { ChevronLeft, Ellipsis } from "lucide-react";
import type { FC } from "react";
import { ChatTopBar } from "web_myplann/Chat/Components/Conversation/ChatTopBar";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";

type Props = {
	name: string;
	photo?: string;
	onBack: () => void;
	onOpenActions?: () => void;
};

export const ChatHeader: FC<Props> = ({
	name,
	photo,
	onBack,
	onOpenActions,
}) => {
	const theme = useTheme();

	return (
		<ChatTopBar
			icon={ChevronLeft}
			onIconClick={onBack}
			title={name}
			startAdornment={
				<InitialsAvatar
					name={name}
					photo={photo}
					size={theme.chat.avatar.size.sm}
					initialsVariant="initials"
				/>
			}
			endAdornment={
				onOpenActions && (
					<IconButton variant="ghost" onClick={onOpenActions}>
						<Ellipsis
							size={theme.iconSize.md}
							color={theme.palette.grey[600]}
						/>
					</IconButton>
				)
			}
		/>
	);
};
